module.exports = __webpack_public_path__ + "static/media/1.f72ca83e.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/brest/1.JPG
// module id = 215
// module chunks = 0